<template>
  <!-- 
  <div class="flex_item sc_dashboard">
  -->
  <div class="flex_item sc_dashboard"
       :style="{ backgroundImage: 'url(' + imageBackGround + ')' }">

    <div class="flex_item flex_top">
      <div class="flex_item flex_date">{{ formattedDate }} <br> {{ formattedDay }} </div>
      <div class="flex_item flex_time">{{ formattedTime }}</div>
      <div class="flex_item flex_prjname"
           :style="{ backgroundImage: 'url(' + imageZzfPrjName + ')' }"></div>
      <div class="flex_item flex_time"></div>
      <div class="flex_item flex_time"></div>
    </div>

    <div class="flex_item flex_center_row">
      <div class="flex_item flex_chart_1p4">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">房源信息</div>
        <div class="flex_item sc_item sc_house"
             :style="{ backgroundImage: 'url(' + imageChartHouse + ')' }">
          <ChartHouse :updata="dataHouse" />
        </div>
      </div>
      <div class="flex_item flex_chart_1p4">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">本月租退</div>
        <ChartOperation :updata="dataOperation" />
      </div>
      <div class="flex_item flex_chart_1p2">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">能耗趋势</div>
        <ChartEnergy :updata="dataEnergy" />
      </div>
    </div>

    <div class="
                     flex_item
                     flex_center_row">
      <div class="flex_item flex_chart_1p4">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">住户信息</div>
        <ChartTenant :updata="dataTenant" />
      </div>
      <div class="flex_item flex_chart_1p4">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">设备情况</div>
        <ChartDevice :updata="dataDevice" />
      </div>
      <div class="flex_item flex_chart_1p4">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">报修记录</div>
        <ChartRepair :updata="dataRepair"
                     clrSubInfo='#00d8ff' />
      </div>
      <div class="flex_item flex_chart_1p4">
        <div class="flex_item flex_item_title"
             :style="{ backgroundImage: 'url(' + imageChartTitle + ')' }">告警记录</div>
        <ChartAlarm :updata="dataAlarm"
                    clrSubInfo='#FFD800' />
      </div>
    </div>

  </div> <!-- dashboard -->
</template>

<script>
import fetch from '@/common/api'
import ChartHouse from '@/views/home/zzfComponents/house/chart.vue'
import ChartOperation from '@/views/home/zzfComponents/operation/chart.vue'
import ChartEnergy from '@/views/home/zzfComponents/energy/chart.vue'
import ChartDevice from '@/views/home/zzfComponents/device/chart.vue'
import ChartTenant from '@/views/home/zzfComponents/tenant/panel.vue'
import ChartRepair from '@/views/home/zzfComponents/records/table.vue'
import ChartAlarm from '@/views/home/zzfComponents/records/table.vue'

export default {
  components: {
    ChartHouse,
    ChartOperation,
    ChartEnergy,
    ChartDevice,
    ChartTenant,
    ChartRepair,
    ChartAlarm
  },
  data() {
    return {
      imageBackGround: require('@/assets/img/zzf_board_back.jpg'), // 背景图片
      imageZzfPrjName: require('@/assets/img/zzf_board_title.png'), // 顶部标题图片
      imageChartTitle: require('@/assets/img/zzf_chart_title.png'), // 图表部件标题
      imageChartHouse: require('@/assets/img/zzf_chart_hose_back.png'), // 房源信息背景图片
      currentDate: new Date(), // 当前时间

      timerTime: null,
      timerTotal: null,
      // 图表数据
      reqType: 0,
      dataHouse: {
        seriesData: [
          { value: 70, name: '已分配' },
          { value: 30, name: '未分配' }
        ]
      },
      dataOperation: {
        xData: ['2月', '3月'],
        seriesData: [
          { name: '入住', values: [30, 70] },
          { name: '退租', values: [30, 70] }
        ]
      },
      dataEnergy: {
        xData: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        seriesData: {
          water: [60, 70, 60, 70, 60, 80, 75, 85, 90, 75, 85, 75],
          electricity: [50, 60, 50, 60, 70, 90, 85, 90, 75, 85, 75, 85]
        }
      },
      dataTenant: {
        total: 10,
        male: 3,
        female: 7
      },
      dataDevice: {
        seriesData: [
          {
            value: 1,
            name: '总数'
          },
          {
            value: 1,
            name: '在线'
          },
          {
            value: 0,
            name: '离线'
          }
        ]
      },
      dataRepair: {
        tableData: [
          {
            mainText: '主标题1',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题2',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题3',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题4',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题5',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题4',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题5',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题4',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题5',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题4',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '主标题5',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          }
        ]
      },
      dataAlarm: {
        tableData: [
          {
            mainText: '告警1',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '告警2',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '告警3',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '告警4',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          },
          {
            mainText: '告警5',
            subText: '副标题内容',
            date: '2023-10-01',
            time: '14:30'
          }
        ]
      }
    }
  },
  computed: {
    //计算属性，具有缓存机制，只有当依赖的数据发生变化时才会重新计算，从而节省了不必要的性能开销
    formattedDate() {
      const year = this.currentDate.getFullYear()
      const month = this.currentDate.getMonth() + 1
      const day = this.currentDate.getDate()
      return `${year}年${month}月${day}日`
    },
    formattedDay() {
      const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return days[this.currentDate.getDay()]
    },
    formattedTime() {
      const hours = this.currentDate.getHours().toString().padStart(2, '0')
      const minutes = this.currentDate.getMinutes().toString().padStart(2, '0')
      const seconds = this.currentDate.getSeconds().toString().padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    }
  },
  mounted() {
    this.requestChartData()
    this.timerTime = setInterval(() => {
      this.currentDate = new Date()
    }, 1000)
    this.timerTotal = setInterval(() => {
      this.requestChartData()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timerTime)
    clearInterval(this.timerTotal)
  },
  methods: {
    requestChartData() {
      fetch.bigScreenZzf({ reqType: this.reqType }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            if (typeof data.dataHouse !== 'undefined') {
              this.dataHouse = data.dataHouse
            }
            if (typeof data.dataOperation !== 'undefined') {
              this.dataOperation = data.dataOperation
            }
            if (typeof data.dataEnergy !== 'undefined') {
              this.dataEnergy = data.dataEnergy
            }
            if (typeof data.dataTenant !== 'undefined') {
              this.dataTenant = data.dataTenant
            }
            if (typeof data.dataDevice !== 'undefined') {
              this.dataDevice = data.dataDevice
            }
            if (typeof data.dataRepair !== 'undefined') {
              this.dataRepair = data.dataRepair
            }
            if (typeof data.dataAlarm !== 'undefined') {
              this.dataAlarm = data.dataAlarm
            }

            this.reqType = this.reqType + 1
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style scoped>
.sc_dashboard {
  display: flex;
  height: 100vh;
  flex-direction: column;
  background-size: cover;
  background-position: center;
}
/* 公共 */
.flex_item {
  border: 0px solid #969696;
  box-sizing: border-box; /* 确保内边距和边框不会影响宽度计算 */
}
/* 顶端容器 */
.flex_top {
  display: flex;
  flex: 0 0 138px;
}
/* 中心容器 */
.flex_center_row {
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-left: 80px;
  margin-right: 80px;
}

/*图表容器*/
.flex_chart_1p2 {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.flex_chart_1p4 {
  display: flex;
  flex-direction: column;
  width: 25%;
}

/* -------------------------------部件-------------------------------- */
/* 日期时间 */
.flex_date {
  flex: 0 0 150px;
  padding-left: 32px;
  margin-top: 15px;
  font-size: 24px;
  font-weight: bold;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.flex_time {
  flex: 0 0 150px;
  margin-top: 21px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
/* 项目标题图片 */
.flex_prjname {
  flex: 1;
  margin-top: 14px;
  /*overflow: hidden;  隐藏超出容器的部分 */
  background-repeat: no-repeat;
  background-position: top;
}

/* 图表标题 */
.flex_item_title {
  flex: 0 0 43px;
  background-position: left bottom;
  background-repeat: no-repeat;
  padding-left: 50px;
  text-align: left;
  font-style: normal;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 29px;
  letter-spacing: 5px;
  text-transform: none;
}

/* 图表元素 */
.sc_item {
  flex: 1;
  width: 100%;
  height: 100%;
}

/* 房源信息背景 */
.sc_house {
  background-size: 65%; /* 背景图片覆盖整个div */
  background-position: center; /* 背景图片居中 */
  background-repeat: no-repeat; /* 背景图片不重复 */
}
</style>